<template>
  <div>
    <div>
      <aha-modal @hide="hide()" :title="$i18nPresenter.t('Leave presentation')">
        <div v-if="leavePresentations.length === 1">
          <div>
            <p>
              {{ $i18nPresenter.t("You are leaving this shared presentation: ") }}<strong>
                {{ leavePresentations[0].name }} [{{ leavePresentations[0].accessCode }}]
              </strong>
            </p>
            <p>{{ $i18nPresenter.t("Once you leave, you can no longer edit it.") }}</p>
          </div>
        </div>
        <div class="max-h-52" v-else>
          <span>{{ $i18nPresenter.t("Are you sure you want to leave these presentations:") }}</span>
          <ul class="mt-2 ml-4 list-disc">
            <li
              class="mt-1"
              :key="presentation.id"
              v-for="presentation in leavePresentations"
            >
              {{ presentation.name }} [{{ presentation.accessCode }}]
            </li>
          </ul>
        </div>

        <template #action>
          <aha-antd-button
            class="mr-4"
            variant="secondary"
            :disabled="leavingPresentations"
            @click="hide()"
          >
            <span>{{ $i18nPresenter.t("Cancel") }}</span>
          </aha-antd-button>
          <aha-antd-button
            variant="danger"
            :disabled="leavingPresentations"
            @click="handleLeavePresentations()"
            v-aha-emit-action
            name="presentation-leave"
            is-loading-inline
            :submitting="leavingPresentations"
          >
            {{ $i18nPresenter.t("Leave") }}
          </aha-antd-button>
        </template>
      </aha-modal>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

// api
import PresentationApi from '@/api/presentation'

// constants
import eventCategories from '@/constant/eventCategories'

// utils
import utils from '@/util'

export default {
  props: {
    leavePresentations: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leavingPresentations: false,
    }
  },
  computed: {
    ...mapState({
      presentations: (state) => state.presentations,
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    ...mapActions(['setPresentationsAction', 'setErrorOnInternalServerAction']),
    async handleLeavePresentations() {
      this.leavingPresentations = true

      try {
        await PresentationApi.removeCollaborators(this.leavePresentations[0].id, {
          collaborators: [this.currentUser.email],
        })
        this.$store.dispatch(
          'setPresentationsAction',
          this.$store.state.presentations.filter((p) => p.id !== this.leavePresentations[0].id),
        )

        if (this.leavePresentations.length === 1) {
          utils.showToastSuccess(this.$i18nPresenter.t('Left this presentation successfully.'))
        } else {
          utils.showToastSuccess(`${this.$i18nPresenter.t('Leave')} ${this.leavePresentations.length} ${this.$i18nPresenter.t('presentations')}`)
        }

        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation > Leave collaboration > Succeeded')
      } catch (error) {
        if (this.leavePresentations.length === 1 && this.leavePresentations[0]) {
          this.setErrorOnInternalServerAction(`Cannot leave presentation ${this.leavePresentations[0].name}`)
        } else {
          this.setErrorOnInternalServerAction(`Cannot leave ${this.leavePresentations.length} presentations`)
        }

        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation > Leave collaboration > Failed')
        throw error
      } finally {
        this.leavingPresentations = false
        this.hide()
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
